module.exports = "function renderSpreadsheet () {\n  return (\n    <MultiGrid\n      cellRenderer={cellRenderer}\n      columnWidth={columnWidth}\n      columnCount={28}\n      fixedColumnCount={1}\n      fixedRowCount={1}\n      height={height}\n      rowHeight={40}\n      rowCount={100}\n      width={width}\n    />\n  );\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/multi-grid.js
 ** module id = 287
 ** module chunks = 0
 **/